// Wait for window to fully load including all resources
$(window).on('load', function() {
    if ($('.our-companies-container').hasClass('no-animation')) {
        console.log('No animation for this block');
        return;
    } else {
        // Function to check viewport width and determine if we should enable the scrolling functionality
        function isDesktopViewport() {
            return $(window).width() > 900;
        }
        
        // Get all company content elements
        const $companyContents = $('.our-companies_content');
        const totalCompanies = $companyContents.length;
        const $container = $('.our-companies-container');
        
        // Skip if there are no companies or just one company or if viewport is too small
        if (totalCompanies <= 1 || !isDesktopViewport()) {
            if (!isDesktopViewport()) {
                // Show all companies by default for mobile view
                $companyContents.addClass('active').css({
                    'position': 'relative',
                    'opacity': '1',
                    'visibility': 'visible'
                });
                
                // Remove spacer for mobile view
                $('.our-companies-spacer').css('height', '0');
                $('.our-companies').css('height', 'auto').css('position', 'relative');
            }
            return;
        }
        
        // Set up variables for scroll tracking
        let currentIndex = 0;
        
        // Function to show the company content at the specified index
        function showCompanyContent(index) {
            if (index < 0) index = 0;
            if (index >= totalCompanies) index = totalCompanies - 1;
            
            // Instead of toggling the entire content, let's only toggle the card part
            $companyContents.each(function(i) {
                const $content = $(this);
                const $card = $content.find('.our-companies_card');
                
                if (i === index) {
                    // Show this card with a fade in
                    $content.addClass('active');
                    $card.css({
                        'opacity': '1',
                        'visibility': 'visible'
                    });
                } else {
                    // Hide other cards
                    $content.removeClass('active');
                    $card.css({
                        'opacity': '0',
                        'visibility': 'hidden'
                    });
                }
            });
            
            currentIndex = index;
        }
        
        // Calculate the height needed for the spacer to enable enough scrolling
        function setSpacerHeight() {
            // Set the spacer height to accommodate all companies
            // Height = viewport height * number of companies
            const viewportHeight = $(window).height();
            const spacerHeight = viewportHeight * totalCompanies;
            $('.our-companies-spacer').height(spacerHeight);
        }
        
        // Initial setup
        showCompanyContent(0);
        setSpacerHeight();
        
        // Handle window resize and check viewport width
        let previousViewportState = isDesktopViewport();
        
        $(window).on('resize', function() {
            const currentViewportState = isDesktopViewport();
            
            // Check if we crossed the threshold
            if (previousViewportState !== currentViewportState) {
                // Reload the page to reset all styles and behavior
                // Or alternatively implement a more sophisticated toggle mechanism
                if (currentViewportState) {
                    // Switched to desktop view
                    setSpacerHeight();
                    $companyContents.not(':first').removeClass('active');
                    $companyContents.css({
                        'position': '',
                        'opacity': '',
                        'visibility': ''
                    });
                    $(window).trigger('scroll');
                } else {
                    // Switched to mobile view
                    $('.our-companies-spacer').css('height', '0');
                    $('.our-companies').css('height', 'auto').css('position', 'relative');
                    $companyContents.addClass('active').css({
                        'position': 'relative',
                        'opacity': '1',
                        'visibility': 'visible'
                    });
                }
                
                previousViewportState = currentViewportState;
            } else if (currentViewportState) {
                // Still in desktop mode, just update the spacer height
                setSpacerHeight();
            }
        });
        
        // Trigger scroll check once to ensure proper initialization
        setTimeout(function() {
            if (isDesktopViewport()) {
                $(window).trigger('scroll');
            }
        }, 500);
        
        // Handle scroll events
        $(window).on('scroll', function() {
            // Get the scroll position and container position
            const scrollTop = $(this).scrollTop();
            const containerTop = $container.offset().top;
            
            // Calculate how far we've scrolled into the section
            const scrolledIntoSection = scrollTop - containerTop;
            
            // If section is in view and we're scrolling into it
            if (scrolledIntoSection >= 0) {
                // Calculate which company to show based on scroll position
                const viewportHeight = $(window).height();
                const scrollRatio = scrolledIntoSection / viewportHeight;
                const newIndex = Math.min(Math.floor(scrollRatio), totalCompanies - 1);
                
                // Only update if the index changed
                if (newIndex !== currentIndex) {
                    showCompanyContent(newIndex);
                }
            } else {
                // If we're scrolled above the section, ensure the first company is shown
                if (currentIndex !== 0) {
                    showCompanyContent(0);
                }
            }
        });
        
        // Force an immediate scroll check
        $(window).scroll();
        
        // Add a small animation to make the first slide visible (in case there's an issue with the scroll event)
        setTimeout(function() {
            $companyContents.first().addClass('active');
        }, 1000);
    }
});
